import Button from 'assets/components/button/Button';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import { OrderType } from 'config/Api.Config';
import { useProductProvider } from '../Product.Hooks';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import ProductType from 'models/enums/ProductType';
import PurchaseType from 'models/enums/PurchaseType';
import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import ProductCategory from 'models/productManagement/productCategory/Model.ProductCategory';
import useApi from 'assets/hooks/api/useApi';
import PricingDistributionTemplate from 'models/productManagement/pricingDistributionTemplate/Model.PricingDistributionTemplate';

export default function ProductFilters() {
  const { lang } = getLocales();
  const { listApi } = useProductProvider();

  const categoriesPayload = useApi({ action: ProductCategory.list });
  const distributionsPayload = useApi({ action: PricingDistributionTemplate.list });

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      search={listApi.body?.search}
      onSearch={(search) => listApi.execute((body) => ({ ...body, search, offset: 0 }))}
      filters={listApi?.body}
      onFilter={(newFilers) => listApi?.execute({ ...newFilers, offset: 0 })}
      onReset={listApi?.reset}
      onOpen={() => {
        if (!categoriesPayload?.payload) categoriesPayload?.execute();
        if (!distributionsPayload?.payload) distributionsPayload?.execute();
      }}
      headerActions={
        <DropdownButton
          buttonMedia={<Icon class="fas-sort" />}
          horizontalPosition="auto_fixed"
          verticalPosition="auto_fixed"
          htmlElementProps={{ title: lang.sort }}
          subcomponents={ThemeDropdownButtonPopup}
          dropdownOptions={
            <>
              <Button
                class={ThemeButtonMenuItem}
                render={lang.newerFirst}
                media={<Icon class="fas-caret-up" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: undefined,
                  orderType: undefined,
                })}
              />
              <Button
                class={ThemeButtonMenuItem}
                render={lang.olderFirst}
                media={<Icon class="fas-caret-up" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: 'id',
                  orderType: OrderType.asc,
                })}
              />
              <Button
                class={ThemeButtonMenuItem}
                render={lang.ascendingByName}
                media={<Icon class="fas-caret-up" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: 'Name',
                  orderType: OrderType.asc,
                  thenBy: ['Name', 'Code'],
                  thenType: [OrderType.asc, OrderType.asc, OrderType.asc],
                })}
              />
              <Button
                class={ThemeButtonMenuItem}
                render={lang.descendingByName}
                media={<Icon class="fas-caret-down" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: 'Name',
                  orderType: OrderType.desc,
                  thenBy: ['Name', 'Code'],
                  thenType: [OrderType.desc, OrderType.desc, OrderType.desc],
                })}
              />
            </>
          }
        />
      }
      render={({ tempFilters, setFilters }) => (
        <>
          <SelectInput
            name="productType"
            label={lang.type}
            data={Object.values(ProductType).map((id) => ({
              id,
              title: lang[id] || id,
            }))}
            value={tempFilters?.productType}
            onChange={({ productType }) => setFilters({ ...tempFilters, productType })}
            icon={<Icon class="if-cloud" />}
          />
          <SelectInput
            name="categoryId"
            label={lang.program}
            data={categoriesPayload?.payload?.data?.map((item) => ({
              ...item.displayInfo,
              icon: <Icon class="fas-box" />,
            }))}
            value={tempFilters?.categoryId}
            onChange={({ categoryId }) => setFilters({ ...tempFilters, categoryId })}
            icon={<Icon class="fas-box" />}
          />
          <SelectInput
            name="pricingDistributionTemplateId"
            label={lang.pricingDistributionTemplate}
            data={distributionsPayload?.payload?.data?.map((it) => it.displayInfo)}
            value={tempFilters.pricingDistributionTemplateId}
            onChange={({ pricingDistributionTemplateId }) => {
              setFilters({ ...tempFilters, pricingDistributionTemplateId });
            }}
            icon={<Icon class="fas-balance-scale" />}
          />
          <SelectInput
            name="allowedVehiclePurchaseType"
            label={lang.allowedVehiclePurchaseTypes}
            data={Object.values(PurchaseType).map((id) => ({
              id,
              title: lang[id.toLowerCase().replace(/\s+/g, '')],
            }))}
            value={tempFilters?.allowedVehiclePurchaseType}
            onChange={({ allowedVehiclePurchaseType }) => setFilters({ ...tempFilters, allowedVehiclePurchaseType })}
            isMultiselect
            icon={<Icon class="fas-dollar-sign" />}
          />
        </>
      )}
    />
  );
}
